import React, { useRef } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import Dropdown from '../../../components/base/Dropdown/Dropdown';
import { Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';

export default function CameraViewTypeSelector(props) {
  const {
    disabled = false,
    onSelect = () => {},
    selected = 0,
    list = [],
  } = props;
  const anchorElement = useRef(null);
  const intl = useIntl();
  const { formatMessage } = intl;
  let iconName = '';
  const inputOption = list.find(i => i.value === selected);
  iconName = inputOption ? inputOption.icon : 'view-type-0';

  return (
    <Dropdown
      dropBottom
      usePortal
      disabled={disabled}
      className="camera-view-type-selector"
    >
      <Dropdown.Toggle>
        <div ref={anchorElement} className={classNames('camera-view-type-toggle', { disabled })}>
          {formatMessage({ id: 'view.type' })}
          <Icons customIcon icon={iconName} className="type-icon" />
          <Icons customIcon icon="arrow-down" className="arrow-icon" />
        </div>
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="camera-view-type-options-wrapper"
        anchorElement={anchorElement}
        classNamePortal=""
      >
        <div className="select-options-list">
          {list.map((item, key) => (
            <div
              key={key}
              className={classNames('select-option', { selected: item.value === selected })}
              onClick={() => { onSelect(item.value); }}
            >
              <Icons customIcon icon={item.icon} className="type-icon" />
            </div>
          ))}
        </div>
      </Dropdown.Menu>
    </Dropdown>
  );
}
